import { render } from "./AdministratorTopCard.vue?vue&type=template&id=085e63c0&scoped=true"
import script from "./AdministratorTopCard.vue?vue&type=script&lang=js"
export * from "./AdministratorTopCard.vue?vue&type=script&lang=js"

import "./AdministratorTopCard.vue?vue&type=style&index=0&id=085e63c0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085e63c0"]])

export default __exports__